export const PageHeaderSimple = ({ children }) => <span className="typography-h2">{children}</span>

const PageHeader = ({ children }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} className="typography-h2">
    {children}
  </div>
)
export default PageHeader
